// @flow

import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import './styles.scss'

type Props = {
  children?: React.Node,
  desiredLocation: string,
  illustrationSrc: string,
  realisticChoice: string,
  title: string,
  upperLimit: string
}

export function RenterProfile ({
  children,
  desiredLocation,
  illustrationSrc,
  realisticChoice,
  title,
  upperLimit
}: Props) {
  return (
    <div className='column renter-profile' lang='de_ch'>
       <img src={illustrationSrc} alt='' className='ui centered small image' />
      <h4 className='ui infographic centered header'>{title}</h4>

      <table className='ui definition very basic compact small infographic table'>
        <tbody>
          <tr className='top aligned'>
            <td className='single line'>
              Budget für Miete <br />
              <span className='light'>(ohne NK)</span>
            </td>
            <td>{upperLimit}</td>
          </tr>
          <tr className='top aligned'>
            <td>Wunschobjekt</td>
            <td>{desiredLocation}</td>
          </tr>
        </tbody>
      </table>

      <div className='description'>{children}</div>

      <table className='ui inverted purple very compact infographic unstackable table'>
        <tbody>
          <tr>
            <td className=''>Realistische Wahl</td>
            <td className=''>
              <strong>{realisticChoice}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
